import { PlanningsNotAllocReason } from 'src/entities/PlanningsNotAllocReasons.entity';

/**
 * 割当不可の理由を legRun ID 単位にまとめる。
 *
 * Why not shipment_order_id でも引けるようにする: API の `order_id` は**常に leg_run.id**
 * である。送信側が `leg_run.id.to_s` を入れ (planning_api の shipment_order_leg_run.rb:501 /
 * tour_request_builder.rb:127 / order_request_builder.rb:107)、
 * not_alloc_reasons_controller.rb:24 がそのまま返す。未割当リストも legRunId で引く
 * (ConvenienceDispatchUnassignedList.tsx:1053)。
 *
 * 両建てにすると、leg_run.id と別案件の shipment_order_id がたまたま同値のときに
 * **無関係な案件へ理由が付く**。両者は別テーブルの連番なので値域が重なる。
 */
export function buildNotAllocReasonsByOrderId(
  reasons: PlanningsNotAllocReason[] | undefined,
): Map<number, PlanningsNotAllocReason[]> {
  const byOrderId = new Map<number, PlanningsNotAllocReason[]>();

  (reasons ?? []).forEach((reason) => {
    const bucket = byOrderId.get(reason.order_id) ?? [];
    bucket.push(reason);
    byOrderId.set(reason.order_id, bucket);
  });

  return byOrderId;
}
